/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router';
import { Form, Input, Button, Row, Col, DatePicker, Select, Table, Upload, message, Icon } from 'antd';
import moment from 'moment';
import { DmsTab, DisplayForm, TableView } from 'Components';
import { openNotice } from 'Utils';
import ProductModal from '../inventory/productModal';
import { receivedPaymentDetail } from '../../service/financialMgm';
const FormItem = Form.Item;

class ReceivedPaymentDetail extends React.Component {
  
  constructor (props) {
    super(props);
    this.state = {
      opts: ['回款'],
      btnLoad: false,
      detail: {
        productId: '11',
        price: '223'
      },
      endOpen: false, // 控制失效时间选择
      rows: [/*{
          key: '0',
          id: '1',
          status: '10010101',
          type: '2017-12-29',
          date: '100',
          customerName: '10',
          purchaseUnit: '300',
          amount: '个啊实打实大',
          cash: '元器件',
          date1: '已提交',
          customerName1: '2017-12-12',
          purchaseUnit1: '1111111'
        }, {
          key: '1',
          id: '2',
          status: '10010102',
          type: '2017-12-30',
          date: '200',
          customerName: '20',
          purchaseUnit: '222',
          amount: '件休闲鞋',
          cash: 'TG精品',
          date1: '已提交',
          customerName1: '2017-12-12',
          purchaseUnit1: '1111111'
        }*/],
      total: 1,
      searchObj: {
        /*name: '',
        category: [],
        active: '',*/
        id: '',
        s: 10,
        p: 1
      },
      loading: true
    }
    this.pageChange = this.pageChange.bind(this);
  }

  goBack = () => {
    hashHistory.goBack();
  };

  disabledStartDate = (startValue) => {
  }
  disabledEndDate = (endValue) => {
  }
  handleStartOpenChange = (open) => {
    if (!open) {
      this.setState({ endOpen: true });
    }
  }
  handleEndOpenChange = (open) => {
    this.setState({ endOpen: open });
  }

  pageChange (page, pageSize) {
    // console.log('pageChange');
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, () => {
      this.initData();
    })
  }

  /*获取详情数据*/
  initData () {
    // this.state.searchObj.id = this.props.routeParams.id;
    var obj = this.state.searchObj;
    this.setState({
      loading: true
    })
    receivedPaymentDetail(obj).then(result => {
      if (result.status) {
        let detail = JSON.parse(JSON.stringify(result.data));
        delete detail.writenoffDetailVos;
        this.setState({
          rows: result.data.writenoffDetailVos || [],
          total: result.total,
          detail: detail,
          loading: false
        })
      } else {
        message.error(result.message);
      }
    })
  }

  componentDidMount () {
    // console.log(this);
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        id: this.props.routeParams.id
      }
    }, () => {
      this.initData();
    });
    //设置离开当前路由时的钩子函数
    // this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  render () {
    const { opts, detail, btnLoad, endOpen, rows, total, searchObj, loading } = this.state;
    const props = {
      name: 'file',
      action: '//jsonplaceholder.typicode.com/posts/',
      headers: {
        authorization: 'authorization-text',
      },
      onChange(info) {
        if (info.file.status !== 'uploading') {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} file upload failed.`);
        }
      },
    };
    let self = this;
    const tableViewProps = {
      loading: loading,//更新表格数据中
      rowKey: 'id',
      pageParam: {
        total: total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'num'
        }, {
          title: '订单号',
          dataIndex: 'orderNum'
        },
        {
          title: '订单时间',
          dataIndex: 'orderDate',
          render: (text) => text ? new Date(text).format('yyyy-MM-dd') : ''
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
            render: (text, record, index) => {
                return record.orderAmount.toFixed(2);
            }
        },
        {
          title: '已核销金额',
          dataIndex: 'writenoffCount',
            render: (text, record, index) => {
                return record.writenoffCount.toFixed(2);
            }
        },
        {
          title: '未核销金额',
          dataIndex: 'unWritenoffCount',
            render: (text, record, index) => {
                return record.unWritenoffCount.toFixed(2);
            }
        },
        {
          title: '本次核销金额',
          dataIndex: 'writenoffCountCur',
            render: (text, record, index) => {
                return record.writenoffCountCur.toFixed(2);
            }
        }
      ],
      rows
    };
    const displayData = [
      {label: '收款编号', value: detail.recoverCode},
      {label: '收款日期', value: detail.recoverDate},
      {label: '收款方式', value: detail.recoverType},
      {label: '客户名称', value: detail.cusName},
      {label: '收款金额', value: detail.recoverCount},
      {label: '剩余未核销金额', value: detail.unWritenoffCount},
      {label: '收款凭证', value: detail.attachmentDto, type: 'attachList', clickFn: function(item){
        console.log(item);
      }}
    ];
    return <div>
      <DmsTab options={opts} defaultKey={0}>
        <Button onClick={this.goBack}>返回</Button>
      </DmsTab>
      <div className="dms-table-box">
        <DisplayForm dataSource={displayData} perRow="2"/>
        <div>
          <DmsTab className="white-bg no-border" options={['核销订单']} defaultKey={0}/>
          <div className="dms-table-box">
            <TableView {...tableViewProps}/>
          </div>
        </div>
      </div>
    </div>
  }
};
export default ReceivedPaymentDetail;


// WEBPACK FOOTER //
// ./src/routes/financialMgm/receivedPaymentDetail.js